var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottom2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    d: "M 0 192 L 26.7 186.7 C 53.3 181 107 171 160 165.3 C 213.3 160 267 160 320 176 C 373.3 192 427 224 480 245.3 C 533.3 267 587 277 640 261.3 C 693.3 245 747 203 800 202.7 C 853.3 203 907 245 960 256 C 1013.3 267 1067 245 1120 213.3 C 1173.3 181 1227 139 1280 154.7 C 1333.3 171 1387 245 1524 205 L 1517 296 L 1513 325 L 1413.3 320 C 1386.7 320 1333 320 1280 320 C 1226.7 320 1173 320 1120 320 C 1066.7 320 1013 320 960 320 C 906.7 320 853 320 800 320 C 746.7 320 693 320 640 320 C 586.7 320 533 320 480 320 C 426.7 320 373 320 320 320 C 266.7 320 213 320 160 320 C 106.7 320 53 320 27 320 L 0 320 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom2);
export default __webpack_public_path__ + "static/media/bottom2.c60e9e2b.svg";
export { ForwardRef as ReactComponent };